import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/format";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    if (user === undefined)
        return (
            <div className="min-h-screen grid place-items-center text-brand-emerald" data-testid="auth-loading">
                <Loader2 className="h-6 w-6 animate-spin" />
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !hasRole(user, roles)) return <Navigate to="/app" replace />;
    return children;
}
